import { render, staticRenderFns } from "./DrugsPrice.vue?vue&type=template&id=bcc83f58&scoped=true"
import script from "./DrugsPrice.vue?vue&type=script&lang=js"
export * from "./DrugsPrice.vue?vue&type=script&lang=js"
import style0 from "./DrugsPrice.vue?vue&type=style&index=0&id=bcc83f58&prod&lang=scss&scoped=true"
import style1 from "./DrugsPrice.vue?vue&type=style&index=1&id=bcc83f58&prod&lang=scss"
import style2 from "./DrugsPrice.vue?vue&type=style&index=2&id=bcc83f58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc83f58",
  null
  
)

export default component.exports